// extracted by mini-css-extract-plugin
export default {"parkingItem":"ParkingDurationItem_parkingItem__kL2tG","arrow":"ParkingDurationItem_arrow__l-qXE","time":"ParkingDurationItem_time__1shAQ","date":"ParkingDurationItem_date__GU5xU"};